const BGM_RESUME = 'rapchik:bgm-resume';
const BGM_DUCK = 'rapchik:bgm-duck';
const BGM_RESTORE = 'rapchik:bgm-restore';
const BGM_PAUSE = 'rapchik:bgm-pause';
const BGM_PLAY = 'rapchik:bgm-play';
const BGM_PAGE_ON = 'rapchik:bgm-page-on';
const BGM_PAGE_OFF = 'rapchik:bgm-page-off';
const BGM_PAUSED_KEY = 'rapchik:bgm-paused';
const GAMES_BGM_PATH = '/Games';

let pageBgmEnabled =
  typeof window !== 'undefined' && window.location.pathname === GAMES_BGM_PATH;

export const resumeBgm = () => {
  window.dispatchEvent(new Event(BGM_RESUME));
};

export const duckBgm = () => {
  window.dispatchEvent(new Event(BGM_DUCK));
};

export const restoreBgm = () => {
  window.dispatchEvent(new Event(BGM_RESTORE));
};

export const isBgmPaused = () => {
  try {
    return window.localStorage.getItem(BGM_PAUSED_KEY) === '1';
  } catch {
    return false;
  }
};

export const pauseBgm = () => {
  try {
    window.localStorage.setItem(BGM_PAUSED_KEY, '1');
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(new Event(BGM_PAUSE));
};

export const playBgm = () => {
  try {
    window.localStorage.setItem(BGM_PAUSED_KEY, '0');
  } catch {
    /* ignore quota / private mode */
  }
  window.dispatchEvent(new Event(BGM_PLAY));
};

export const toggleBgm = () => {
  if (isBgmPaused()) playBgm();
  else pauseBgm();
};

export const isPageBgmEnabled = () => pageBgmEnabled;

/** Play BGM only while `/Games` is mounted. Does not change mute preference. */
export const setPageBgmEnabled = (enabled) => {
  pageBgmEnabled = Boolean(enabled);
  window.dispatchEvent(new Event(pageBgmEnabled ? BGM_PAGE_ON : BGM_PAGE_OFF));
};

export const BGM_EVENTS = {
  RESUME: BGM_RESUME,
  DUCK: BGM_DUCK,
  RESTORE: BGM_RESTORE,
  PAUSE: BGM_PAUSE,
  PLAY: BGM_PLAY,
  PAGE_ON: BGM_PAGE_ON,
  PAGE_OFF: BGM_PAGE_OFF,
};
